import { toKebabCase } from "../lodash/toKebabCase";
import { getRelativeImagePath } from "./getRelativeImagePath";

export function getModelIconUrl({ make, model, year }) {
  if (year) {
    return getRelativeImagePath(`/images/icons/vehicles/${toKebabCase(make)}-${toKebabCase(model)}-${toKebabCase(year)}.webp`);
  }
  return getRelativeImagePath(`/images/icons/${toKebabCase(make)}-${toKebabCase(model)}.png`);
}
